import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Card, Spinner, Table, Alert, Form, Button } from "react-bootstrap";
import { ProductContext } from "../context/AppContext";
import Header from "./Header";
import { Link } from "react-router-dom";
import { all_routes } from "./router/all_routes";

const Transport = () => {
  const { userId } = useContext(ProductContext);
  const authtoken = localStorage.getItem("token");

  const [studentId, setStudentId] = useState(null);
  const [attendanceData, setAttendanceData] = useState([]);
  const [transportDetails, setTransportDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  useEffect(() => {
    const fetchStudentId = async () => {
      try {
        const response = await fetch(`https://api.mirai.healthcare/api/student?regs_id=${userId}`, {
          headers: { "x-auth": `${authtoken}` }
        });
        const data = await response.json();
        if (data.success && data.message.length > 0) {
          const studentData = data.message[0];
          setStudentId(studentData.id);
        }
      } catch (err) {
        console.error("Error fetching student ID:", err);
      }
    };

    fetchStudentId();
  }, [userId]);


  console.log("Student ID:", studentId);
  const handleSearch = async (e) => {
    e.preventDefault();
    if (!fromDate || !toDate || !studentId) return;

    setLoading(true);
    try {
      const attendanceRes = await fetch(
        `https://api.mirai.healthcare/api/attendance/transportAttendance?student_id=${28}&from_date=${fromDate}&to_date=${toDate}`
      );
      const attendanceJson = await attendanceRes.json();
      setAttendanceData(attendanceJson.transport_attendance || []);
    } catch (err) {
      console.error("Error fetching attendance:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <Header />
      <Container className="mt-4">


        <Card className="mb-4 shadow-sm">
          <Card.Body>
            <h5>Select Date Range</h5>
            <Form onSubmit={handleSearch}>
              <Row className="align-items-end">
                <Col md={4}>
                  <Form.Group controlId="fromDate">
                    <Form.Label>From Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="toDate">
                    <Form.Label>To Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Button variant="primary" type="submit" className="mt-3 w-100">
                    Search Attendance
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>



        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        ) : (
          attendanceData.length > 0 && (
            <Card className="shadow-sm">
              <Card.Body>
                <h5 className="mb-3">🗓️ Attendance Records</h5>
                <Table responsive striped bordered hover>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Status</th>
                      <th>In Time</th>
                      <th>Out Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {attendanceData.map((item) => (
                      <tr key={item.id}>
                        <td>{item.date}</td>
                        <td className={item.status === "present" ? "text-success" : "text-danger"}>
                          {item.status.toUpperCase()}
                        </td>
                        <td>{item.in_time}</td>
                        <td>{item.out_time}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          )
        )}
      </Container>
    </div>
  );
};

export default Transport;
